import { createIcon } from '@chakra-ui/react';

export const MerchantOutlineIcon = createIcon({
  displayName: 'MerchantOutlineIcon',
  path: (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        // width="16"
        // height="17"
        viewBox="0 0 16 17"
        fill="none"
      >
        <path
          d="M5.87329 1.8335L3.45996 4.2535"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.127 1.8335L12.5403 4.2535"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.33301 5.73324C1.33301 4.4999 1.99301 4.3999 2.81301 4.3999H13.1863C14.0063 4.3999 14.6663 4.4999 14.6663 5.73324C14.6663 7.16657 14.0063 7.06657 13.1863 7.06657H2.81301C1.99301 7.06657 1.33301 7.16657 1.33301 5.73324Z"
          stroke="#6E6789"
          strokeWidth="1.5"
        />
        <path
          d="M6.50684 9.8335V12.2002"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M9.57324 9.8335V12.2002"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M2.33301 7.1665L3.27301 12.9265C3.48634 14.2198 3.99967 15.1665 5.90634 15.1665H9.92634C11.9997 15.1665 12.3063 14.2598 12.5463 13.0065L13.6663 7.1665"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    </>
  ),
});
